import { createTheme } from "@mui/material/styles";
import { ThemeProvider as StyledComponentsThemeProvider } from "styled-components";

const muiTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0088CF",
    },
    secondary: {
      main: "#A5E0FF",
    },
    background: {
      default: "#c6c6c6",
      paper: "#ffffff",
    },
    text: {
      primary: "#FBFEFF",
    },
  },
  typography: {
    fontFamily: "Arimo, sans-serif",
  },
  spacing: 8,
});

const customTheme = {
  colors: {
    primary: "#0088CF",
    secondary: "#A5E0FF",
    primaryBackground: "#1F2735",
    surface60: "#2B3342",
    surface70: "#1F2735",
    surface80: "#141B25",
    surface90: "#0D1219",
    surface100: "#000000",
    textPrimary: "#F8F8F8",
    textVariant: "#DEDFE0",
    outline: "#A1A5AC",
    background: "#000000",
    text: "#FBFEFF",
  },
};

const theme = { ...muiTheme, ...customTheme };

export { theme, StyledComponentsThemeProvider };
